import { render, staticRenderFns } from "./Unbindofficialaccountdia.vue?vue&type=template&id=cf2a66ba&scoped=true"
import script from "./Unbindofficialaccountdia.vue?vue&type=script&lang=js"
export * from "./Unbindofficialaccountdia.vue?vue&type=script&lang=js"
import style0 from "./Unbindofficialaccountdia.vue?vue&type=style&index=0&id=cf2a66ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf2a66ba",
  null
  
)

export default component.exports